export enum SociOrderSessionStatusValues {
  CREATED = 'CREATED',
  FOOD_ORDERING = 'FOOD_ORDERING',
  DRINK_ORDERING = 'DRINK_ORDERING',
  CLOSED = 'CLOSED',
}

export enum SociProductTypeValues {
  FOOD = 'FOOD',
  DRINK = 'DRINK',
}

export enum DepositMethodValues {
  STRIPE = 'STRIPE',
  BANK_TRANSFER = 'BANK_TRANSFER',
}
